export default __webpack_public_path__ + "static/illustration-1-9f93459811b79f285f833542feedfd61.png";